import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { LinkSection } from '../../types/link';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';

import { Section, SectionAttributes } from '../../../app/types/section';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type ArrowLinkSection = Section<
  {
    numColumns: 12;
    link: LinkSection;
    indentedLink?: boolean;
  } & SectionAttributes,
  [
    'numColumns',
    'link',
  ],
  'arrow-link'
>;

@Component({
  selector: 'app-arrow-link',
  styleUrls: ['./arrow-link.component.scss'],
  templateUrl: './arrow-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    RouterOrExternalLinkDirective,
    StandaloneLinkComponent,
    FsButtonComponent,
],
})
export class ArrowLinkComponent extends SectionComponent<ArrowLinkSection> implements OnInit {

  @HostBinding('attr.kb-section') private section?: '';

  public override ngOnInit() {
    super.ngOnInit();

    this.section = this.attributes.indentedLink ? '' : undefined;
  }
}
